import StaticPageLayout from "../components/StaticPageLayout";
import { COMPANY_PAGES } from "../data/companyPagesContent";

const CareersPage = () => (
  <StaticPageLayout page={COMPANY_PAGES.careers} testId="careers-page" />
);

export default CareersPage;
